import colors from "../../foundations/colors.module.scss";
import typography from "../../foundations/typography.module.scss";
/**
 * Base menu paper styles used across TextField, InlineSelect, and other components.
 */
export const baseMenuPaperStyles = {
  borderRadius: 8,
  margin: '8px'
};

/**
 * Base menu item styles used across TextField, InlineSelect, and other components.
 */
export const baseMenuItemStyles = {
  borderRadius: 6,
  margin: '4px 8px',
  transition: 'background-color 0.2s ease, color 0.2s ease',
  fontFamily: typography.fontFamilyLight,
  fontSize: typography.fontSizeP1,
  color: colors.dark700,
  padding: '8px 12px',
  '&:hover': {
    backgroundColor: colors.dark70
  },
  '&.Mui-selected': {
    backgroundColor: colors.dark100,
    color: "".concat(colors.dark900, " !important")
  },
  '&.Mui-disabled': {
    color: colors.dark400,
    opacity: 0.6
  },
  '&.Mui-focusVisible': {
    backgroundColor: 'transparent'
  },
  '& .MuiTouchRipple-root': {
    display: 'none'
  },
  '&:hover, &:focus:not(.Mui-selected)': {
    backgroundColor: colors.dark70
  },
  '&:first-child': {
    marginTop: 0
  },
  '&:last-child': {
    marginBottom: 0
  }
};

/**
 * Base menu styles hook for use in components.
 * Returns styles that include both menu paper and menu item styles.
 */
export const useBaseMenuStyles = function useBaseMenuStyles() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    menu: {
      maxHeight: props.menuMaxHeight,
      '& .MuiPaper-root': baseMenuPaperStyles,
      '& .MuiMenuItem-root': baseMenuItemStyles
    },
    menuPaper: baseMenuPaperStyles,
    menuItem: baseMenuItemStyles
  };
};